export const ERROR_STORE_KEY = 'error';
